<template>
  <div>
    <div class='quotation'>
      <template v-if="owner">
        <div class='summary'>
          <div>
            <span>{{ $t('合計加工時間') }}</span>
            <span class='cost'>{{ formatTime(totalTime) }}</span>
          </div>
          <div>
            <span>{{ $t('加工費') }}</span>
            <span class='cost'>{{ formatPrice(costCutting) }}</span>
          </div>
        </div>
        <div class='detail'>
          <a v-show='!isDetail' class='toggle' @click='toggleDetail'>
            <span>{{ $t('詳細を表示') }}</span><i v-html='svg.arrowDown'></i>
          </a>
          <a v-show='isDetail' class='toggle' @click='toggleDetail'>
            <span>{{ $t('詳細を非表示') }}</span><i v-html='svg.arrowUp'></i>
          </a>
          <ul v-show='isDetail'>
            <li>
              <div class='owner-est__block'>
                <div class='owner-est__header'>
                  <span>{{ $t('合計加工時間') }}</span><span>{{ formatTime(totalTime) }}</span><!-- detail label kept -->
                </div>
                <ul>
                  <li v-for='item in timeItems' :key="item.name">
                    <span class='name'>{{ item.name }}<br />({{ item.detail }})</span>
                    <span>{{ formatTime(item.time) }}</span>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div class='owner-est__block'>
                <div class='owner-est__header'>
                  <span>{{ $t('加工費') }}</span><span>{{ formatPrice(costCutting) }}</span>
                </div>
              </div>
            </li>
            <li>
              <div class='owner-est__block'>
                <div class='owner-est__header'>
                  <span>{{ $t('消費税(10%)') }}</span><span>{{ formatPrice(costTax) }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </template>
      <template v-else>
        <div class='summary'>
          <div>
            <span>{{ $t('合計金額 (税込)') }}</span>
            <span class='cost'>{{ formatPrice(totalCost) }} ~</span>
          </div>
          <div>
            <span>{{ $t('出荷目安 (営業日)') }}</span>
            <span class='cost'>{{ $t(deliveryDate) }}</span>
          </div>
        </div>
        <div class='detail'>
          <a v-show='!isDetail' class='toggle' @click='toggleDetail'>
            <span>{{ $t('詳細を表示') }}</span><i v-html='svg.arrowDown'></i>
          </a>
          <a v-show='isDetail' class='toggle' @click='toggleDetail'>
            <span>{{ $t('詳細を非表示') }}</span><i v-html='svg.arrowUp'></i>
          </a>
          <ul v-show='isDetail' class='cost-items'>
            <li v-for='item in costItems' :key="item.name">
              <span class='name'>{{ item.name }}<br />({{ item.detail }})</span>
              <span>{{ formatPrice(item.price) }}</span>
            </li>
            <li>
              <span class='name'>{{ $t('送料') }}</span>
              <span>{{ $t('別途見積もり') }}</span>
            </li>
            <li>
              <span style='margin-right: 10px;'>※</span>
              <span>{{ $t('加工費・仕上げ費は、加工拠点により設定価格が異なるため、表示されている金額は概算見積金額となります。') }}</span>
            </li>
            <li>
              <span style='margin-right: 10px;'>※</span>
              <span>{{ $t('上記に加え、別途送料・梱包費が発生します。依頼後にそれらを含めた正式なお見積りをご連絡致します。') }}</span>
            </li>
          </ul>
        </div>
      </template>
    </div>
    <div>
      <ul>
        <li v-if="isLabMode">
          <button
            class='button highlighted-btn'
            @click.prevent.stop='$emit("downloadsbp")'
            data-ga-click-event="SBPダウンロード"
            v-bind:disabled='isLoading'
          ><i v-html='svg.orderGreen'></i><span>{{ $t('SBPダウンロード') }}</span></button>
        </li>

        <li v-if="!isLabMode">
          <button
            class='button highlighted-btn'
            @click.prevent.stop='$emit("order")'
            data-ga-click-event="加工依頼へ"
            v-bind:disabled='isLoading'
          ><i v-html='svg.orderGreen'></i><span>{{ $t('加工依頼へ') }}</span></button>
        </li>
        <li>
          <button
            class='button step back'
            @click.prevent.stop='$emit("tostep1")'
            v-bind:disabled='isLoading'
          ><span>{{ $t('条件設定に戻る') }}</span></button>
        </li>
        <li v-if="!properties.hasScrew">
          <button
            class='button step back'
            @click.prevent.stop='$emit("tostep2")'
            v-bind:disabled='isLoading'
          ><span>{{ $t('配置設定に戻る') }}</span></button>
        </li>
        <li>
          <button
            class='button'
            @click.prevent.stop='$emit("quotation")'
            data-ga-click-event="見積りPDF"
            v-bind:disabled='isLoading'
          ><i v-html='svg.pdf'></i><span>{{ $t('見積もりPDF') }}</span></button>
        </li>
        <li v-if="isLabMode">
          <div class='external-link'>
            <i v-html='svg.external'></i>
            <button
              @click.prevent.stop='$emit("toNextSbpPreview")'
            data-ga-click-event="新プレビューへ"
            >{{ $t('新プレビューへ') }}</button>
          </div>
        </li>
        <li v-if="!isLabMode">
          <div class='notes'>
            <i v-html='svg.note'></i>
            <a
              href='https://docs.emarf.co/1525709244d2803bad64c6a42c9715f5'
              target='_blank'
              data-ga-click-event="配送・品質・仕上げの詳細について"
            >{{ $t('配送・品質・仕上げの詳細について') }}</a>
          </div>
        </li>
      </ul>
    </div>
    <div class='plugin-footer'>
      <ul>
        <li>
          <label>{{ $t('タイトル') }}</label>
          <input type='text' name='title' id='title' v-model='properties.name' placholder='Title...' />
        </li>
        <li>
          <button
            class='button highlighted-btn'
            @click='$emit("savemypage")'
            data-ga-click-event="マイページに保存"
            v-bind:disabled='isLoading'
          ><i v-html='svg.saveGreen'></i><span>{{ $t('マイページに保存') }}</span></button>
        </li>
        <li>
          <button
            class='button'
            @click='$emit("tomypage")'
            v-bind:disabled='isLoading'
          ><i v-html='svg.back'></i><span>{{ $t('保存せずに戻る') }}</span></button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { formatPrice, formatTime } from '@/assets/javascripts/Formatter';

import svgLogo from '@/assets/images/e.svg';
import svgLabLogo from '@/assets/images/lab.svg';
import svgArrowDown from '@/assets/images/plugin/arrow_down.svg';
import svgArrowUp from '@/assets/images/plugin/arrow_up.svg';
import svgBack from '@/assets/images/plugin/back.svg';
import svgEdit from '@/assets/images/plugin/edit.svg';
import svgExternal from '@/assets/images/plugin/external.svg';
import svgNesting from '@/assets/images/plugin/nesting.svg';
import svgNote from '@/assets/images/plugin/note.svg';
import svgOrder from '@/assets/images/plugin/order.svg';
import svgOrderGreen from '@/assets/images/plugin/order_green.svg';
import svgPdf from '@/assets/images/plugin/pdf.svg';
import svgSave from '@/assets/images/plugin/save.svg';
import svgSaveGreen from '@/assets/images/plugin/save_green.svg';

export default {
  name: 'PluginStep3Menu',
  components: {},

  props: {
    owner: {
      type: Boolean,
      default: false
    },
    properties: Object,
    materials: Array,
    material_assortments: Array,
    error: Boolean,
    totalCost: {
      type: Number,
      default: 0
    },
    deliveryDate: {
      type: String,
      default: '要問合せ' // will be translated via $t() in template if needed
    },
    totalTime: {
      type: Number,
      default: 0
    },
    costCutting: {
      type: Number,
      default: 0
    },
    costTax: {
      type: Number,
      default: 0
    },
    systemFeeRatio: {
      type: Number,
      default: 0
    },
    costItems: {
      type: Array,
      default: () => { return []; }
    },
    timeItems: {
      type: Array,
      default: () => { return []; }
    },
    isLoading: Boolean,
    isLabMode: Boolean
  },

  data () {
    return {
      isDetail: false,
      svg: {
        logo: svgLogo,
        labLogo: svgLabLogo,
        pdf: svgPdf,
        edit: svgEdit,
        order: svgOrder,
        orderGreen: svgOrderGreen,
        back: svgBack,
        arrowUp: svgArrowUp,
        arrowDown: svgArrowDown,
        nesting: svgNesting,
        note: svgNote,
        external: svgExternal,
        save: svgSave,
        saveGreen: svgSaveGreen
      }
    };
  },

  methods: {
    formatPrice (price) {
      // console.log(price, typeof price);
      if (price === undefined) return 0;
      if (typeof price !== 'number') return price;
      return formatPrice(price);
    },

    formatTime (time) {
      if (time === undefined) return 0;
      return formatTime(time);
    },

    toggleDetail () {
      this.isDetail = !this.isDetail;
    }
  }
};

</script>

<style lang="scss" scoped>

.summary {
  div:first-child {
    margin-bottom: 12px;
  }
  span.cost {
    font-size: 18px !important;
  }
}

.owner-est__block {
  width: 100%;
  .owner-est__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  ul {
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/plugin/PluginStep3Menu.vue